import { ref } from 'vue'
import ApiService from '@/service/api.service'

export const useProductPolicies = (productId: string | undefined) => {
  const productPolicies = ref<[]>([])
  const error = ref<any>(undefined)
  const isLoading = ref<Boolean>(false)

  const fetchPolicies = async () => {
    if (!productId) return

    isLoading.value = true
    try {
      const response = await ApiService.getProductPolicies(productId)
      productPolicies.value = response.data
    } catch (err) {
      error.value = err
    } finally {
      isLoading.value = false
    }
  }

  fetchPolicies()

  return {
    productPolicies,
    mutate: fetchPolicies,
    isLoading,
    error,
  }
}
